var exports = {
  "z": "x93eb46d8--617476--root",
  "m": "x93eb46d8--617476--separator",
};

module.exports = exports;
